import {__} from 'js/tool/page/current';
import {FbSpendCapAction} from 'graphql/generated';
import {AdAccountType, CustomerStatus} from 'graphql/generated-fbgraph/graphql';
import dataset from 'js/reusable/form/elements/phoneInput/dataset';

export function getAccountTypeOptions() {
	return [
		{value: 'BUSINESS', label: __('fb:business acc type')},
	];
}

export function getOffices(clientBMs) {
	if (!clientBMs) {
		return;
	}

	const offices = clientBMs.map(bmItem => {
		const bm = dataset.find(item => item.ISO.toLowerCase() === bmItem.businessCountryId.toLowerCase());

		return {
			...bm,
			label: bm.flag + ' Httpool ' + bm.name,
			value: bmItem.externalAdvertiserId,
		};
	});

	return offices;
}

export function getStatusIcon(isDeleted, isActivated) {
	if (isDeleted) {
		return 'fa-minus-circle';
	}

	if (isActivated) {
		return 'fa-play-circle';
	}

	return 'fa-pause-circle';
}

export function getStatusOptions(excludeInactive = false) {
	if (excludeInactive) {
		return [
			{value: CustomerStatus.ACTIVE, label: __('fb:acc active')},
			{value: CustomerStatus.DELETED, label: __('fb:acc deleted')},
		];
	}

	return [
		{value: CustomerStatus.ACTIVE, label: __('fb:acc active')},
		{value: CustomerStatus.PENDING, label: __('fb:acc pending')},
		{value: CustomerStatus.DELETED, label: __('fb:acc deleted')},
	];
}

export function getDefaultStatusOption(customerStatus) {
	if (customerStatus === 'DELETED') {
		return {value: 'deleted', label: __('fb:acc deleted')};
	}

	if (customerStatus === 'ACTIVE') {
		return {value: 'active', label: __('fb:acc active')};
	}

	return {value: 'pending', label: __('fb:acc pending')};
}

export function getAccountPayTypeOptions(isDefaultSettings = false) {
	if (isDefaultSettings) {
		return [
			{value: AdAccountType.PREPAID, label: __('fb:prepaid')},
			{value: 'UNSET', label: __('fb:automatic detection')},
			{value: AdAccountType.POSTPAID, label: __('fb:postpaid')},
		];
	}

	return [
		{value: AdAccountType.PREPAID, label: __('fb:prepaid')},
		{value: AdAccountType.POSTPAID, label: __('fb:postpaid')},
	];
}

export function getDefaultAccountPayTypeOption(type) {
	if (type === 'UNSET') {
		return {value: 'UNSET', label: __('fb:automatic detection')};
	}

	if (type === 'POSTPAID') {
		return {value: 'POSTPAID', label: __('fb:postpaid')};
	}

	if (type === 'CREDIT_LINE') {
		return {value: 'CREDIT_LINE', label: __('fb:credit line')};
	}

	return {value: 'PREPAID', label: __('fb:prepaid')};
}

export function getSpendCapTransactionModes(options) {    
	if (options?.isUnlimited) {
		return [
			{value: FbSpendCapAction.RemoveAll, label: __('fb:remove all')},
			{value: FbSpendCapAction.Set, label: __('fb:reset and set new value')},
		];
	}

	const setAction = 
		(options?.includeSetAction ?? true) 
			? [{value: FbSpendCapAction.Set, label: __('fb:reset and set new value')}] 
			: [];

	if (options?.fundsLeft === options?.minFundsLeft) {
		return [
			{value: FbSpendCapAction.Add, label: __('fb:add')},
			...setAction,
		];
	}

	if (options?.fundsLeft <= (options?.minFundsLeft ?? 0.10)) {
		return [
			{value: FbSpendCapAction.Add, label: __('fb:add')},
			{value: FbSpendCapAction.Remove, label: __('fb:remove')},
			...setAction,
		];
	}

	return [
		{value: FbSpendCapAction.Add, label: __('fb:add')},
		{value: FbSpendCapAction.Remove, label: __('fb:remove')},
		{value: FbSpendCapAction.RemoveAll, label: __('fb:remove all')},
		...setAction,
	];
}
